import React from "react";

export default function Marquee({ items }) {
  const row = [...items, ...items];
  return (
    <div className="relative overflow-hidden border-y border-line bg-ink py-5 text-cream">
      <div className="flex w-max animate-marquee whitespace-nowrap will-change-transform">
        {row.map((t, i) => (
          <span key={i} className="mx-8 flex items-center gap-8 font-serif text-2xl md:text-4xl font-light tracking-tight">
            {t}
            <span className="text-terra text-xl">✳</span>
          </span>
        ))}
      </div>
    </div>
  );
}
